import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { functions } from 'react-flag-icon-css';
import FlagIcon from '../FlagIcon';
import IconField from './IconField';
import { extendedStateType } from '../../types';
import { NO_STATE } from '../../hooks/useExtendedState';

FlagIconField.propTypes = {
    label: PropTypes.node.isRequired,
    value: PropTypes.string,
    inputId: PropTypes.string,
    onChange: PropTypes.func,
    className: PropTypes.string,
    isRequired: PropTypes.bool,
    messageOnEmpty: PropTypes.string,
    onReset: PropTypes.func,
    isChanged: PropTypes.bool,
    state: extendedStateType,
};

FlagIconField.defaultProps = {
    onChange: undefined,
    inputId: null,
    className: '',
    isRequired: false,
    messageOnEmpty: '',
    onReset: undefined,
    isChanged: undefined,
    value: undefined,
    state: NO_STATE,
};

const availableIcons = functions.countries.getCountryCodes();

function FlagIconField(props) {
    const {
        label,
        value,
        inputId,
        onChange,
        className,
        isRequired,
        messageOnEmpty,
        onReset,
        isChanged,
        state,
    } = props;
    const { t } = useTranslation();
    const renderFn = (flagCode) => <FlagIcon code={flagCode} squared />;
    return (
        <IconField
            label={label}
            value={value}
            inputId={inputId}
            onChange={onChange}
            className={className}
            isRequired={isRequired}
            messageOnEmpty={messageOnEmpty}
            onReset={onReset}
            isChanged={isChanged}
            availableIcons={availableIcons}
            renderFn={renderFn}
            iconsPerPage={30}
            state={state}
            searchPlaceholder={t('flag-icon-field.placeholder.search')}
            noIconPlaceholder={t('flag-icon-field.placeholder.no-flags-found')}
            noSelectedPlaceholder={t('flag-icon-field.placeholder.select-flag')}
        />
    );
}

export default FlagIconField;
